import { Button } from '@/components/ui/button';
import { Modal } from './modal';
import { DialogClose } from '@/components/ui/dialog';
import { LoadingSpinner } from '@/components/loading-spinner';

interface ConfirmationModalProps {
  title: string;
  description: string;
  buttonLabel: string;
  isLoading?: boolean;
  isOpen: boolean;
  handleDelete: () => void;
  handleCancel: () => void;
}

export const ConfirmationModal = ({
  handleDelete,
  title,
  description,
  handleCancel,
  buttonLabel,
  isLoading = false,
  isOpen = false,
}: ConfirmationModalProps) => {
  const Footer = () => (
    <>
      <DialogClose asChild>
        <Button onClick={handleCancel} variant='outline'>
          Cancel
        </Button>
      </DialogClose>
      <Button onClick={handleDelete} disabled={isLoading}>
        {isLoading ? (
          <>
            <LoadingSpinner /> {buttonLabel}
          </>
        ) : (
          buttonLabel
        )}
      </Button>
    </>
  );

  return (
    <Modal
      isDialogOpen={isOpen}
      footer={<Footer />}
      title={title}
      description={description}
      setIsDialogOpen={handleCancel}
    />
  );
};
